/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MonitoringFilterProtocolResponse,
  PortfolioAssetProtocolsBulkUpdateAssetRequest,
  PortfolioAssetProtocolsCreateAssetByPresignedRequest,
  PortfolioAssetProtocolsCreateCollectionRequest,
  PortfolioAssetProtocolsCreateCollectionResponse,
  PortfolioAssetProtocolsDeleteAssetRequest,
  PortfolioAssetProtocolsDeleteCollectionRequest,
  PortfolioAssetProtocolsGetAllAssetListRequest,
  PortfolioAssetProtocolsGetAllAssetListResponse,
  PortfolioAssetProtocolsGetAllCollectionsResponse,
  PortfolioAssetProtocolsGetAssetCountByBrandRequest,
  PortfolioAssetProtocolsGetAssetCountByBrandResponse,
  PortfolioAssetProtocolsGetAssetListRequest,
  PortfolioAssetProtocolsGetAssetListResponse,
  PortfolioAssetProtocolsGetAssetPresignedUrlRequest,
  PortfolioAssetProtocolsGetAssetPresignedUrlResponse,
  PortfolioAssetProtocolsGetAssetRequest,
  PortfolioAssetProtocolsGetAssetResponse,
  PortfolioAssetProtocolsGetIpDocumentsRequest,
  PortfolioAssetProtocolsGetIpDocumentsResponse,
  PortfolioAssetProtocolsGetIprFilterOptionRequest,
  PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetRequest,
  PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetResponse,
  PortfolioAssetProtocolsUpdateAssetByPresignedRequest,
  PortfolioAssetProtocolsUpdateCollectionRequest,
  PortfolioCopyrightsProtocolsAddCopyrightRequest,
  PortfolioCopyrightsProtocolsAddDocumentRequest,
  PortfolioCopyrightsProtocolsAddDocumentResponse,
  PortfolioCopyrightsProtocolsDeleteCopyrightRequest,
  PortfolioCopyrightsProtocolsDeleteDocumentRequest,
  PortfolioCopyrightsProtocolsGetCopyrightsRequest,
  PortfolioCopyrightsProtocolsGetCopyrightsResponse,
  PortfolioCopyrightsProtocolsGetDocumentDetailsRequest,
  PortfolioCopyrightsProtocolsGetDocumentDetailsResponse,
  PortfolioCopyrightsProtocolsGetDocumentsRequest,
  PortfolioCopyrightsProtocolsGetDocumentsResponse,
  PortfolioCopyrightsProtocolsUpdateCopyrightRequest,
  PortfolioCopyrightsProtocolsUpdateDocumentRequest,
  PortfolioDesignProtocolsAddDesignRequest,
  PortfolioDesignProtocolsAddDesignResponse,
  PortfolioDesignProtocolsDeleteDesignRequest,
  PortfolioDesignProtocolsGetDesignDetailRequest,
  PortfolioDesignProtocolsGetDesignDetailResponse,
  PortfolioDesignProtocolsGetDesignListResponse,
  PortfolioDesignProtocolsRequest,
  PortfolioDesignProtocolsUpdateDesignRequest,
  PortfolioIpDocProtocolsAddBrandRequest,
  PortfolioIpDocProtocolsAddBrandResponse,
  PortfolioIpDocProtocolsDeleteBrandRequest,
  PortfolioIpDocProtocolsGetBrandDetailRequest,
  PortfolioIpDocProtocolsGetBrandDetailResponse,
  PortfolioIpDocProtocolsGetBrandListResponse,
  PortfolioIpDocProtocolsGetDownloadUrlRequest,
  PortfolioIpDocProtocolsGetDownloadUrlResponse,
  PortfolioIpDocProtocolsGetLicenseeListResponse,
  PortfolioIpDocProtocolsGetOwnerListResponse,
  PortfolioIpDocProtocolsGetUploadUrlRequest,
  PortfolioIpDocProtocolsGetUploadUrlResponse,
  PortfolioIpDocProtocolsUpdateBrandRequest,
  PortfolioModelProtocolsExportModelListRequest,
  PortfolioModelProtocolsExportModelListResponse,
  PortfolioModelProtocolsGetModelCountRequest,
  PortfolioModelProtocolsGetModelCountResponse,
  PortfolioModelProtocolsGetModelIdListRequest,
  PortfolioModelProtocolsGetModelIdListResponse,
  PortfolioModelProtocolsGetModelListRequest,
  PortfolioModelProtocolsGetModelListResponse,
  PortfolioTrademarkProtocolsAddTrademarkRequest,
  PortfolioTrademarkProtocolsAddTrademarkResponse,
  PortfolioTrademarkProtocolsDeleteTrademarkRequest,
  PortfolioTrademarkProtocolsGetTrademarkDetailRequest,
  PortfolioTrademarkProtocolsGetTrademarkDetailResponse,
  PortfolioTrademarkProtocolsGetTrademarkListResponse,
  PortfolioTrademarkProtocolsRequest,
  PortfolioTrademarkProtocolsUpdateTrademarkRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class IpPortfolio<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags IpPortfolio
   * @name OwnerList
   * @request GET:/ip_doc/owner
   */
  ownerList = (params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsGetOwnerListResponse, any>({
      path: `/ip_doc/owner`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name LicenseeList
   * @request GET:/ip_doc/licensee
   */
  licenseeList = (params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsGetLicenseeListResponse, any>({
      path: `/ip_doc/licensee`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name PresignedUploadCreate
   * @request POST:/ip_doc/presigned/upload
   */
  presignedUploadCreate = (data: PortfolioIpDocProtocolsGetUploadUrlRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsGetUploadUrlResponse, any>({
      path: `/ip_doc/presigned/upload`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name PresignedDownloadCreate
   * @request POST:/ip_doc/presigned/download
   */
  presignedDownloadCreate = (data: PortfolioIpDocProtocolsGetDownloadUrlRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsGetDownloadUrlResponse, any>({
      path: `/ip_doc/presigned/download`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name BrandList
   * @request GET:/ip_doc/brand
   */
  brandList = (params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsGetBrandListResponse, any>({
      path: `/ip_doc/brand`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name BrandDetailCreate
   * @request POST:/ip_doc/brand/detail
   */
  brandDetailCreate = (data: PortfolioIpDocProtocolsGetBrandDetailRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsGetBrandDetailResponse, any>({
      path: `/ip_doc/brand/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name BrandAddCreate
   * @request POST:/ip_doc/brand/add
   */
  brandAddCreate = (data: PortfolioIpDocProtocolsAddBrandRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioIpDocProtocolsAddBrandResponse, any>({
      path: `/ip_doc/brand/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name BrandUpdateCreate
   * @request POST:/ip_doc/brand/update
   */
  brandUpdateCreate = (data: PortfolioIpDocProtocolsUpdateBrandRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/brand/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name BrandDeleteCreate
   * @request POST:/ip_doc/brand/delete
   */
  brandDeleteCreate = (data: PortfolioIpDocProtocolsDeleteBrandRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/brand/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsDocListCreate
   * @request POST:/ip_doc/copyrights/doc/list
   */
  copyrightsDocListCreate = (data: PortfolioCopyrightsProtocolsGetDocumentsRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioCopyrightsProtocolsGetDocumentsResponse, any>({
      path: `/ip_doc/copyrights/doc/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsDocAddCreate
   * @request POST:/ip_doc/copyrights/doc/add
   */
  copyrightsDocAddCreate = (data: PortfolioCopyrightsProtocolsAddDocumentRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioCopyrightsProtocolsAddDocumentResponse, any>({
      path: `/ip_doc/copyrights/doc/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsDocDetailsCreate
   * @request POST:/ip_doc/copyrights/doc/details
   */
  copyrightsDocDetailsCreate = (
    data: PortfolioCopyrightsProtocolsGetDocumentDetailsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PortfolioCopyrightsProtocolsGetDocumentDetailsResponse, any>({
      path: `/ip_doc/copyrights/doc/details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsDocUpdateCreate
   * @request POST:/ip_doc/copyrights/doc/update
   */
  copyrightsDocUpdateCreate = (data: PortfolioCopyrightsProtocolsUpdateDocumentRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/copyrights/doc/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsDocDeleteCreate
   * @request POST:/ip_doc/copyrights/doc/delete
   */
  copyrightsDocDeleteCreate = (data: PortfolioCopyrightsProtocolsDeleteDocumentRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/copyrights/doc/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsCopyrightListCreate
   * @request POST:/ip_doc/copyrights/copyright/list
   */
  copyrightsCopyrightListCreate = (
    data: PortfolioCopyrightsProtocolsGetCopyrightsRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PortfolioCopyrightsProtocolsGetCopyrightsResponse, any>({
      path: `/ip_doc/copyrights/copyright/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsCopyrightAddCreate
   * @request POST:/ip_doc/copyrights/copyright/add
   */
  copyrightsCopyrightAddCreate = (data: PortfolioCopyrightsProtocolsAddCopyrightRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/copyrights/copyright/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsCopyrightUpdateCreate
   * @request POST:/ip_doc/copyrights/copyright/update
   */
  copyrightsCopyrightUpdateCreate = (
    data: PortfolioCopyrightsProtocolsUpdateCopyrightRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip_doc/copyrights/copyright/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CopyrightsCopyrightDeleteCreate
   * @request POST:/ip_doc/copyrights/copyright/delete
   */
  copyrightsCopyrightDeleteCreate = (
    data: PortfolioCopyrightsProtocolsDeleteCopyrightRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/ip_doc/copyrights/copyright/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignCreate
   * @request POST:/ip_doc/design
   */
  designCreate = (data: PortfolioDesignProtocolsRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioDesignProtocolsGetDesignListResponse, any>({
      path: `/ip_doc/design`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignGetAllCountriesCreate
   * @request POST:/ip_doc/design/get-all-countries
   */
  designGetAllCountriesCreate = (data: PortfolioDesignProtocolsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/ip_doc/design/get-all-countries`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignGetAllClassesCreate
   * @request POST:/ip_doc/design/get-all-classes
   */
  designGetAllClassesCreate = (data: PortfolioDesignProtocolsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/ip_doc/design/get-all-classes`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignDetailCreate
   * @request POST:/ip_doc/design/detail
   */
  designDetailCreate = (data: PortfolioDesignProtocolsGetDesignDetailRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioDesignProtocolsGetDesignDetailResponse, any>({
      path: `/ip_doc/design/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignAddCreate
   * @request POST:/ip_doc/design/add
   */
  designAddCreate = (data: PortfolioDesignProtocolsAddDesignRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioDesignProtocolsAddDesignResponse, any>({
      path: `/ip_doc/design/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignUpdateCreate
   * @request POST:/ip_doc/design/update
   */
  designUpdateCreate = (data: PortfolioDesignProtocolsUpdateDesignRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/design/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DesignDeleteCreate
   * @request POST:/ip_doc/design/delete
   */
  designDeleteCreate = (data: PortfolioDesignProtocolsDeleteDesignRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/design/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkCreate
   * @request POST:/ip_doc/trademark
   */
  trademarkCreate = (data: PortfolioTrademarkProtocolsRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioTrademarkProtocolsGetTrademarkListResponse, any>({
      path: `/ip_doc/trademark`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkGetAllCountriesCreate
   * @request POST:/ip_doc/trademark/get-all-countries
   */
  trademarkGetAllCountriesCreate = (data: PortfolioTrademarkProtocolsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/ip_doc/trademark/get-all-countries`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkGetAllClassesCreate
   * @request POST:/ip_doc/trademark/get-all-classes
   */
  trademarkGetAllClassesCreate = (data: PortfolioTrademarkProtocolsRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/ip_doc/trademark/get-all-classes`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkDetailCreate
   * @request POST:/ip_doc/trademark/detail
   */
  trademarkDetailCreate = (data: PortfolioTrademarkProtocolsGetTrademarkDetailRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioTrademarkProtocolsGetTrademarkDetailResponse, any>({
      path: `/ip_doc/trademark/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkAddCreate
   * @request POST:/ip_doc/trademark/add
   */
  trademarkAddCreate = (data: PortfolioTrademarkProtocolsAddTrademarkRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioTrademarkProtocolsAddTrademarkResponse, any>({
      path: `/ip_doc/trademark/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkUpdateCreate
   * @request POST:/ip_doc/trademark/update
   */
  trademarkUpdateCreate = (data: PortfolioTrademarkProtocolsUpdateTrademarkRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/trademark/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name TrademarkDeleteCreate
   * @request POST:/ip_doc/trademark/delete
   */
  trademarkDeleteCreate = (data: PortfolioTrademarkProtocolsDeleteTrademarkRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/ip_doc/trademark/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetIprFilterCreate
   * @request POST:/asset/get-ipr-filter
   */
  getIprFilterCreate = (data: PortfolioAssetProtocolsGetIprFilterOptionRequest, params: RequestParams = {}) =>
    this.http.request<MonitoringFilterProtocolResponse, any>({
      path: `/asset/get-ipr-filter`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetAssetCountByBrandCreate
   * @request POST:/asset/get-asset-count-by-brand
   */
  getAssetCountByBrandCreate = (data: PortfolioAssetProtocolsGetAssetCountByBrandRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetAssetCountByBrandResponse, any>({
      path: `/asset/get-asset-count-by-brand`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetAllAssetsCreate
   * @request POST:/asset/get-all-assets
   */
  getAllAssetsCreate = (data: PortfolioAssetProtocolsGetAllAssetListRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetAllAssetListResponse, any>({
      path: `/asset/get-all-assets`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetAssetCreate
   * @request POST:/asset/get-asset
   */
  getAssetCreate = (data: PortfolioAssetProtocolsGetAssetRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetAssetResponse, any>({
      path: `/asset/get-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetAssetListCreate
   * @request POST:/asset/get-asset-list
   */
  getAssetListCreate = (data: PortfolioAssetProtocolsGetAssetListRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetAssetListResponse, any>({
      path: `/asset/get-asset-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DeleteAssetCreate
   * @request POST:/asset/delete-asset
   */
  deleteAssetCreate = (data: PortfolioAssetProtocolsDeleteAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/delete-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetAllCollectionsList
   * @request GET:/asset/get-all-collections
   */
  getAllCollectionsList = (params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetAllCollectionsResponse, any>({
      path: `/asset/get-all-collections`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CreateCollectionCreate
   * @request POST:/asset/create-collection
   */
  createCollectionCreate = (data: PortfolioAssetProtocolsCreateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsCreateCollectionResponse, any>({
      path: `/asset/create-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name UpdateCollectionCreate
   * @request POST:/asset/update-collection
   */
  updateCollectionCreate = (data: PortfolioAssetProtocolsUpdateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/update-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name BulkUpdateAssetCreate
   * @request POST:/asset/bulk-update-asset
   */
  bulkUpdateAssetCreate = (data: PortfolioAssetProtocolsBulkUpdateAssetRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/bulk-update-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name DeleteCollectionCreate
   * @request POST:/asset/delete-collection
   */
  deleteCollectionCreate = (data: PortfolioAssetProtocolsDeleteCollectionRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/asset/delete-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetRelatedIprCreate
   * @request POST:/asset/get-related-ipr
   */
  getRelatedIprCreate = (
    data: PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PortfolioAssetProtocolsGetRelatedIprForNonManufacturedAssetResponse, any>({
      path: `/asset/get-related-ipr`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name GetAllIprCreate
   * @request POST:/asset/get-all-ipr
   */
  getAllIprCreate = (data: PortfolioAssetProtocolsGetIpDocumentsRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetIpDocumentsResponse, any>({
      path: `/asset/get-all-ipr`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CreateAssetPresignedCreate
   * @request POST:/asset/create-asset-presigned
   */
  createAssetPresignedCreate = (
    data: PortfolioAssetProtocolsCreateAssetByPresignedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/asset/create-asset-presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name UpdateAssetPresignedCreate
   * @request POST:/asset/update-asset-presigned
   */
  updateAssetPresignedCreate = (
    data: PortfolioAssetProtocolsUpdateAssetByPresignedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/asset/update-asset-presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name PresignedCreate
   * @request POST:/asset/presigned
   */
  presignedCreate = (data: PortfolioAssetProtocolsGetAssetPresignedUrlRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioAssetProtocolsGetAssetPresignedUrlResponse, any>({
      path: `/asset/presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name CountCreate
   * @request POST:/model/count
   */
  countCreate = (data: PortfolioModelProtocolsGetModelCountRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioModelProtocolsGetModelCountResponse, any>({
      path: `/model/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name ListCreate
   * @request POST:/model/list
   */
  listCreate = (data: PortfolioModelProtocolsGetModelListRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioModelProtocolsGetModelListResponse, any>({
      path: `/model/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name IdListCreate
   * @request POST:/model/id-list
   */
  idListCreate = (data: PortfolioModelProtocolsGetModelIdListRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioModelProtocolsGetModelIdListResponse, any>({
      path: `/model/id-list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags IpPortfolio
   * @name ExportCreate
   * @request POST:/model/export
   */
  exportCreate = (data: PortfolioModelProtocolsExportModelListRequest, params: RequestParams = {}) =>
    this.http.request<PortfolioModelProtocolsExportModelListResponse, any>({
      path: `/model/export`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
